import React from 'react';
import { useDrag } from 'react-dnd';
import { makeStyles } from '@material-ui/core/styles';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const getStyle = (dragEnabled) => {
  return {
    cursor: dragEnabled ? 'move' : 'pointer',
  };
};

const useStyles = makeStyles((theme) => ({
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  icon: {
    color: 'white',
  },
  tile: {},
}));

const DraggableImage = (props) => {
  const classes = useStyles();
  const { tile, dragEnabled, onItemClickHandler } = props;
  const [{ isDragging }, drag] = useDrag({
    item: { tile, type: 'IMG' },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.4 : 1;

  let h = Math.round((320 * tile.image_height) / tile.image_width);
  if (isNaN(h)) {
    h = 'auto';
  }

  const hasLogo = tile.partner_logo && tile.partner_logo !== 'null';

  return (
    <ImageListItem
      style={{ ...props.style, height: props.height }}
      ref={dragEnabled ? drag : null}
      key={tile.title}
      rows={4}
      onClick={() => {
        onItemClickHandler(tile);
      }}
      className={classes.tile}
    >
      <div
        ref={dragEnabled ? drag : null}
        style={{ ...getStyle(dragEnabled), opacity }}
      >
        <LazyLoadImage
          src={tile.image_url ? tile.image_url : tile.img}
          alt={tile.title || tile.name}
          width={320}
          height={h}
          style={{ ...getStyle(dragEnabled), opacity }}
        />

        <ImageListItemBar
          classes={{ title: hasLogo ? 'padding-r-48' : null }}
          title={tile.title || tile.name}
          subtitle={
            <>
              <span className={'subtitle-draggable'}>
                {tile.creator} {tile.year && <>- {tile.year}</>}
                {tile.collection_title && (
                  <>
                    <br />
                    {tile.collection_title}
                  </>
                )}
              </span>
              {hasLogo && (
                <div className={'draggable-image-logo-container'}>
                  <img
                    className={'draggable-image-logo'}
                    src={tile.partner_logo}
                  ></img>
                </div>
              )}
            </>
          }
          position="top"
          actionPosition="left"
          className={classes.titleBar}
        />
      </div>
    </ImageListItem>
  );
};
export default DraggableImage;
